import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <ul className="greenbullet-list">
                                                <li>People are also often more motivated by a need to avoid
                                                    threat than to seek out opportunities
                                                    – because most of us are more aware of threat than reward.
                                                    We are, therefore, seemingly
                                                    more likely to take risks to avoid negative outcomes than to
                                                    achieve positive ones.
                                                </li>

                                            </ul>
                                            <br/>
                                                <div className="border_subtitle">Recent research<a
                                                    className="superscripttext boldlink"
                                                    href="further_info.php?course=300"><sup>3</sup></a> lists
                                                    the top ‘motivators’ at work as:
                                                </div>
                                                <p><span
                                                    className="brown boldtext brownnumberpd">1. </span> Accomplishing
                                                    something worthwhile</p>
                                                <p><span
                                                    className="brown boldtext brownnumberpd">2. </span> Learning
                                                    new things</p>
                                                <p><span
                                                    className="brown boldtext brownnumberpd">3. </span> Personal
                                                    development</p>
                                                <p><span
                                                    className="brown boldtext brownnumberpd">4. </span> Autonomy
                                                </p>

                                                <p>(Interestingly, pay was 12th on the list and chance for
                                                    promotion 17th.)</p>
                                                <p>Since all this refers to the majority of us, it’s worth
                                                    remembering when setting goals, reviewing salaries, putting
                                                    a new team together or just trying to encourage and fire
                                                    people up. It’s useful in everyday interactions, too.</p>
                                                <div
                                                    className="lightgreencontentbg keyquestionpad uiheading greennumberroundbg1">
                                                    <p>The table below gives ideas and tips for motivating other
                                                        people, devised from the research we outlined above.</p>
                                                </div>
                                                <table className="ilead_v_sport tablesrink people_active"
                                                       border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve green_curve1" align="left"
                                                            valign="top" width="50%">Top Motivational Tips
                                                        </th>
                                                    </tr>
                                                    <tr>

                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="50%">
                                                            <div className="paraspace"><p><span
                                                                className="subtiltereg ">Make an assessment of what motivates your colleagues. Do this by talking to and observing them.<br/>Think about the following:</span>
                                                            </p></div>
                                                            <ul className="greenbullet-list">
                                                                <li> What do they say is most important to them
                                                                    at work/home?
                                                                </li>
                                                                <li>What gives them the greatest feeling of
                                                                    achievement and reward?
                                                                </li>
                                                                <li>What switches them off?</li>
                                                                <li> What do they get most emotional about in
                                                                    discussions?
                                                                </li>
                                                                <li className="list-bottom-pad">What do they
                                                                    most value?
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>

                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="50%">
                                                            <div className="paraspace"><p><span
                                                                className="subtiltereg">Do or say things that relate to whatever motivates them</span>
                                                            </p></div>
                                                            <ul className="greenbullet-list">
                                                                <li> It will help to obtain their ‘buy-in’.</li>
                                                                <li> Explain how changes will relate to what
                                                                    they care about.
                                                                </li>
                                                                <li className="list-bottom-pad"> Adapt your own
                                                                    behaviour to include things which motivate
                                                                    them.
                                                                </li>

                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>

                                                        <td className="lightgreen" align="left" valign="top"
                                                            width="50%">
                                                            <div className="paraspace"><p><span
                                                                className="subtiltereg">Use goals/set targets to motivate</span>
                                                            </p></div>
                                                            <ul className="greenbullet-list">
                                                                <li>Make sure you know the difference between a
                                                                    challenge and an unachievable goal.
                                                                </li>
                                                                <li>Set goals for organisational/team
                                                                    requirements but which also give
                                                                    opportunities for personal development,
                                                                    learning and achievement.
                                                                </li>
                                                                <li> Break down the goal or target to smaller
                                                                    ones to give individuals more opportunity to
                                                                    feel they are achieving and progressing.
                                                                </li>
                                                                <li className="list-bottom-pad">Set regular
                                                                    reviews of progress and celebrate successes.
                                                                    Give help and advice to overcome hurdles and
                                                                    re-focus attention.
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>

                                                        <td className="darkgreen" align="left" valign="top"
                                                            width="50%">
                                                            <div className="paraspace"><p><span
                                                                className="subtiltereg">Be transparent</span>
                                                            </p></div>
                                                            <ul className="greenbullet-list">
                                                                <li>Give as much information as possible to
                                                                    ensure people understand why they might be
                                                                    treated differently from their colleagues in
                                                                    terms of pay and conditions.
                                                                </li>
                                                                <li className="list-bottom-pad"
                                                                    style={{background: 'transparent none repeat scroll 0% 0%;'}}>
                                                                    <span
                                                                        className="subtiltereg">Note:</span> such
                                                                    differences should only ever be based on
                                                                    merit or competence.
                                                                </li>
                                                            </ul>


                                                        </td>
                                                    </tr>

                                                    </tbody>
                                                </table>
                                                <p>Up to here, we have dealt with the most basic principles.
                                                    Next we’ll explore the more obvious differences between
                                                    people and their corresponding needs and motivators at
                                                    work…</p>
                                                <div className="left-btn"><div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done">&lt;&lt; Previous </div></div>
                                                <div className="right-btn"><div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}